import React from 'react';
import { PageHeader } from './components/PageHeader';
import { PageSection } from './components/PageSection';
import { PageSubtitle } from './components/PageSubtitle';
import { PageTitle } from './components/PageTitle';
import './style.scss';

export type PageLayoutProps = React.HtmlHTMLAttributes<HTMLElement> & {
  fullScreen?: boolean;
};

export const PageLayout = ({ children, className = '', fullScreen = false, ...props }: PageLayoutProps) => (
  <main className={['page', fullScreen ? 'page-full-screen' : '', className].join(' ')} {...props}>
    {children}
  </main>
);

PageLayout.Header = PageHeader;
PageLayout.Title = PageTitle;
PageLayout.Subtitle = PageSubtitle;
PageLayout.Section = PageSection;
